module.exports = __webpack_public_path__ + "static/media/3.70c5a72f.jpg";